module.exports = __webpack_public_path__ + "static/media/cairo-black.bed14861.woff";